import { render, staticRenderFns } from "./MoondayCreate.vue?vue&type=template&id=51f8313b&scoped=true&"
import script from "./MoondayCreate.vue?vue&type=script&lang=js&"
export * from "./MoondayCreate.vue?vue&type=script&lang=js&"
import style0 from "./MoondayCreate.vue?vue&type=style&index=0&id=51f8313b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8313b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VDatePicker,VDialog,VSpacer,VTimePicker})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f8313b')) {
      api.createRecord('51f8313b', component.options)
    } else {
      api.reload('51f8313b', component.options)
    }
    module.hot.accept("./MoondayCreate.vue?vue&type=template&id=51f8313b&scoped=true&", function () {
      api.rerender('51f8313b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/月亮日記/MoondayCreate.vue"
export default component.exports